'use client'

import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty'
import { User } from '@/lib/types'
import { BookOpenIcon } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { ChatKitPageWrapper } from '../_components/chatkit-page-wrapper'
import { ChatKitLoginGate } from '../_components/chatkit-login-gate'
import { getChatKitConstants } from './_const'

interface IEbookGeneratorClientProps {
  user: User | null
  userApiKey: string
  hasApiKey: boolean
}

/**
 * Client component for eBook Generator
 * Handles ChatKit integration and user interactions
 */
export default function EbookGeneratorClient({
  user,
  userApiKey,
  hasApiKey,
}: IEbookGeneratorClientProps) {
  const t = useTranslations('ebook-generator')
  const constants = getChatKitConstants(t)

  if (!user) {
    return (
      <ChatKitLoginGate
        icon={BookOpenIcon}
        title="Log in to create ebooks with AI"
        description="Preview the ebook workflow and see how long-form assets come together. Sign in to save chapters, manage assets, and export polished PDFs."
        redirectUrl="/chatkit/ebook-generator"
      />
    )
  }

  if (!hasApiKey) {
    return (
      <Empty>
        <EmptyHeader>
          <EmptyMedia variant="icon">
            <BookOpenIcon />
          </EmptyMedia>
          <EmptyTitle>No API Key</EmptyTitle>
          <EmptyDescription>
            Generate an API key inside your workspace settings to unlock the
            Ebook Agent.
          </EmptyDescription>
        </EmptyHeader>
      </Empty>
    )
  }

  return (
    <ChatKitPageWrapper
      user={user}
      userApiKey={userApiKey}
      workflowKey="ebook"
      constants={constants}
      t={t}
      icon={BookOpenIcon}
    />
  )
}
